import { fadeIn, fadeOut } from '@/helpers/jqry-replace';
import Section from "@packages/sections/section";
import {
    enableBodyScroll,
    disableBodyScroll
} from '@/helpers/bodyScrollLockWrapper';
import { EVENT_MINICART_PRODUCT_ADD } from "@/store/events";

const selectors = {
    openButton: '[data-ai-tool-open]',
    modal: '[data-ai-tool-modal]',
    iframe: '[data-ai-tool-iframe]'
};

const AI_TOOL_IFRAME_SRC_BASE = 'https://ai.lashify.com';

class AIToolSection extends Section {
    async onLoad() {
        await super.onLoad();
        
        await this.init();
    }

    async init() {
        const {container} = this;
        if (!container) {
            return;
        }

        try {
            const iframe = container?.querySelector(selectors.iframe);
            if (!iframe) {
                return;
            }

            const modal = container?.querySelector(selectors.modal);
            if (!modal) {
                return;
            }

            this.iframe = iframe;
            this.modal = modal;

            this.registerOpenModalListeners();
            this.registerCloseModalListeners();
        } catch (error) {}
    }

    registerOpenModalListeners() {
        document.body.addEventListener('click', (event) => {
            const target = event?.target?.closest(selectors?.openButton);
            if (!target) {
                return;
            }

            event?.preventDefault();

            const modal = target.dataset.aiToolOpen || 'modal.html';

            this.open(modal);
        });
    }

    registerCloseModalListeners() {
        document.body.addEventListener('click', (event) => {
            const target = event?.target;
            if (!target) {
                return;
            }

            const openBtn = target?.closest(selectors?.openButton);
            if (!!openBtn) {
                return;
            }

            const iframe = target?.closest(selectors?.iframe);
            if (!!iframe) {
                return;
            }

            this.close();
        });

        window.addEventListener('message', (event) => {
            if (event?.data?.type !== 'CLOSE_MODAL') {
                return;
            }

            this.close();
            this.handleResults(event);
        });
    }

    handleResults(event) {
        if (!event) {
            return;
        }

        const {data} = event;
        if (!data) {
            return;
        }

        const {results} = data;
        if (!results) {
            return;
        }

        const resultsFinal = {
            wandType: String(results.wandType || ''),
            averageLengthRecommended: Number(results.averageLengthRecommended || '0'),
            minRecommended: Number(results.minRecommended || '0'),
            maxRecommended: Number(results.maxRecommended || '0'),
        };

        localStorage.setItem('ai-tool-results', JSON.stringify(resultsFinal));

        document.dispatchEvent(new CustomEvent('ai-tool:results', {
            detail: {
                resultsFinal,
            }
        }));

        const {selectedVariantID = null} = results;
        if (!selectedVariantID) {
            return;
        }

        const id = +(selectedVariantID.split('gid://shopify/ProductVariant/')[1] || "0");
        if (!id) {
            return;
        }

        document.dispatchEvent(new CustomEvent(EVENT_MINICART_PRODUCT_ADD, {
            detail: {
                items: [
                    {
                        quantity: 1,
                        id
                    }
                ]
            }
        }));
    }

    open(modal) {
        if (this.modal.style.display === 'block') {
            return;
        }

        this.iframe.src = `${ AI_TOOL_IFRAME_SRC_BASE }/${ modal }`;

        fadeIn(this.modal, 400);

        disableBodyScroll(this.modal);
    }

    close() {
        if (this.modal.style.display === 'none') {
            return;
        }

        this.iframe.src = '';

        fadeOut(this.modal, 400);

        enableBodyScroll(this.modal);
    }
}

export default AIToolSection;

